var _style, _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeloPln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 32",
    style: {
      enableBackground: "new 0 0 56 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000164484670585319242450000000334173486328605589_);}\n\t.st1{fill:#392518;}\n\t.st2{fill:#D7D3C1;}\n\t.st3{fill:#E12E56;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 16,
    r: 16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147939315899671945380000018331780261027191200_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147939315899671945380000018331780261027191200_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    className: "st1",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,8.1h14c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2 c-0.5,1.4-2.5,5.3-7,5.5c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.1L34,23.7c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1h-4.1 c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.2-0.2c0,0,0-0.1,0-0.1v-0.4c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1 c0,0,0.1,0,0.1,0h2.6c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1l4-8c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.1 c0,0-0.1-0.1-0.2-0.1h-2.5c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.2v-0.4c0-0.1,0-0.2,0.1-0.2 c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0h2.8c1.2,0,2.5-0.3,3.5-0.9c1.1-0.7,1.9-1.6,2.5-2.7c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2 c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.2-0.1H30.9c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2 C30.7,8.1,30.8,8.1,30.9,8.1L30.9,8.1L30.9,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35.3,23.9h13.5c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3 c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0H37.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2 c0.5-0.8,1.1-1.5,1.9-2.1c0.5-0.4,1.1-0.7,1.7-0.9c1-0.4,2.2-0.2,3.2-0.2h2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1 c0.1-0.1,0.1-0.2,0.1-0.3v-0.6c0-0.1,0-0.2-0.1-0.3c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0h-2.2c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2l3.9-7.9c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1h2.7 c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3V8.5c0-0.1,0-0.2-0.1-0.3c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0 h-4.1c-0.1,0-0.1,0-0.2,0.1s-0.1,0.1-0.1,0.2l-4,9.5c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.2,0.1c-1,0.1-5.1,0.8-6.6,5.4 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0.1,0.1,0.1C35.2,23.9,35.2,23.9,35.3,23.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40,30.2c-1.9,0-3.8-0.4-5.5-1.1c-1.7-0.7-3.2-1.7-4.5-3c-1.3-1.3-2.3-2.8-3.1-4.5 c-0.7-1.8-1.1-3.6-1.1-5.5s0.4-3.8,1.1-5.5c0.7-1.7,1.7-3.2,3.1-4.5c1.3-1.3,2.8-2.3,4.5-3c1.8-0.7,3.6-1.1,5.5-1.1 s3.8,0.4,5.5,1.1c1.7,0.7,3.2,1.7,4.5,3c1.3,1.3,2.3,2.8,3,4.5c0.7,1.8,1.1,3.6,1.1,5.5s-0.4,3.8-1.1,5.5 c-0.7,1.7-1.7,3.2-3,4.5c-1.3,1.3-2.8,2.3-4.5,3C43.8,29.9,41.9,30.2,40,30.2z M40,2c-7.7,0-14,6.3-14,14s6.3,14,14,14 s14-6.3,14-14S47.7,2,40,2z"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,32c8.8,0,16-7.2,16-16c0-8.8-7.2-16-16-16C7.2,0,0,7.2,0,16C0,24.8,7.2,32,16,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.9,16.9c-1.7,0-3.1-1.5-3.1-3.4c0-1.9,1.4-3.4,3.1-3.4c1.7,0,3.1,1.5,3.1,3.4C26,15.4,24.6,16.9,22.9,16.9 L22.9,16.9z M14.7,23l-6.8-7.3c-1.2-1.3-1.2-3.5,0-4.8c0.6-0.6,1.4-1,2.2-1c0.8,0,1.6,0.4,2.2,1l6.8,7.3c1.2,1.3,1.2,3.5,0,4.8 c-0.6,0.6-1.4,1-2.2,1C16.1,24,15.3,23.6,14.7,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloPln);
export default __webpack_public_path__ + "static/media/velo-pln.397ef84c69f45b8c9022ee8b7f161991.svg";
export { ForwardRef as ReactComponent };